import type { Feature_Flags_Enum } from '@openx/types/gqlTypes.ts';
import { useAuth } from '../../components/AuthContext/context.ts';

type UseFeatureFlag = Feature_Flags_Enum;

export const useFeatureFlag = (flag: UseFeatureFlag): boolean => {
  const { session } = useAuth();
  const feature_flags = session?.account?.feature_flags ?? [];

  return (feature_flags as unknown as Feature_Flags_Enum[]).includes(flag);
};
